/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Saveperyearwithquarterly4Inputs */

const en_saveperyearwithquarterly4 = /** @type {(inputs: Saveperyearwithquarterly4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Save ${i?.amount} per year with quarterly billing`)
};

const de_saveperyearwithquarterly4 = /** @type {(inputs: Saveperyearwithquarterly4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spare ${i?.amount} pro Jahr mit vierteljährlicher Abrechnung`)
};

/**
* | output |
* | --- |
* | "Save {amount} per year with quarterly billing" |
*
* @param {Saveperyearwithquarterly4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const saveperyearwithquarterly4 = /** @type {((inputs: Saveperyearwithquarterly4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Saveperyearwithquarterly4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_saveperyearwithquarterly4(inputs)
	return de_saveperyearwithquarterly4(inputs)
});
export { saveperyearwithquarterly4 as "savePerYearWithQuarterly" }